import {
    BooleanField,
    Datagrid,
    DateField,
    FunctionField,
    ListContextProvider,
    TextField,
    useList,
    useRecordContext
} from "react-admin"
import {IdentifierField} from "../../components/IdentifierField"
import {initField} from "../../shared/utils"
import {useOptions} from "../../shared/hooks/useOptions"
import {Typography} from "@material-ui/core"


export const ReconciliationFileRowDatagrid = () => {
    const record = useRecordContext()
    const { data: options } = useOptions(`reconciliation_file_row`, "GET");
    const listContext = useList({
        data: record.reconciliation_file_row,
        ids: record.reconciliation_file_row.map((value: any) => value.id),
        loading: false,
        loaded: true,
        perPage: 2000
    });
    const newLocal = "Importo"
    return options ? (
        <ListContextProvider value={listContext}>
            <Datagrid>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("description", options)} style={{ whiteSpace: "pre-wrap" }} />
                <FunctionField
                    label={newLocal}
                    render={(tableRecord: any | undefined) => {
                        if (tableRecord.row_type === "I") {
                            return <Typography style={{ color: "green" }}>+ {tableRecord.value}</Typography>
                        } else {
                            return <Typography color="primary">- {tableRecord.value}</Typography>
                        }
                    }}
                />
                <DateField {...initField("value_date", options)} />
                <DateField {...initField("operation_date", options)} />
                <BooleanField {...initField("reconciled", options)} />
            </Datagrid>
        </ListContextProvider>
    ) : null
}